/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_TitleInputs */

const en_admin_tickets_title = /** @type {(inputs: Admin_Tickets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Tickets`)
};

/**
* | output |
* | --- |
* | "Support Tickets" |
*
* @param {Admin_Tickets_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_title = /** @type {((inputs?: Admin_Tickets_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_title(inputs)
});
export { admin_tickets_title as "admin.tickets.title" }